import React        from 'react'

const Container = props => {
    return (
        <div className="contact-container">
            { props.children }
        </div>
    )
}

export default Container
